export const getWorkTimeState = (state: any) => state.workTime;
